import React from 'react';
import App from './App';

import Theme from '@/theme';
import 'react-toastify/dist/ReactToastify.css';

import './i18n';
import GlobalStyle from '@/assets/style/GlobalStyle';
import { render } from "react-dom";

render(
  <React.StrictMode>
    <GlobalStyle />
    <Theme>
      <App />
    </Theme>
  </React.StrictMode>, document.getElementById("root")
);
